// @ts-nocheck
import { getCookie } from "@insite/client-framework/Common/Cookies";
import parseQueryString from "@insite/client-framework/Common/Utilities/parseQueryString";
import Zone from "@insite/client-framework/Components/Zone";
import {
    ExcludeFromNavigation,
    ExcludeFromSignInRequired,
    HideFooter,
    HideFromSearchEngines,
    HideFromSiteSearch,
    HideHeader,
    HorizontalRule,
    MetaDescription,
    MetaKeywords,
    OpenGraphImage,
    OpenGraphTitle,
    OpenGraphUrl,
    StructuredPageData,
} from "@insite/client-framework/Types/FieldDefinition";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";
import { getLocation } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import PageModule from "@insite/client-framework/Types/PageModule";
import PageProps from "@insite/client-framework/Types/PageProps";
import Modals from "@insite/content-library/Components/Modals";
import Page from "@insite/mobius/Page";
import { HasHistory, withHistory } from "@insite/mobius/utilities/HistoryContext";
import {
    getBackOrdersDataView,
    BackOrdersDataViewContext,
} from "@store/Framework/Store/Data/BackOrders/BackOrdersSelectors";
import loadBackOrders from "@store/Framework/Store/Data/BackOrders/Handlers/LoadBackOrders";
import qs from "qs";
import React, { useEffect } from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";
import updateSearchFields from "@store/Framework/Store/Pages/BackOrders/Handlers/UpdateSearchFields";
import { GetBackOrdersApiParameter } from "@store/Framework/Services/BackOrderService";

const mapStateToProps = (state: ApplicationState) => ({
    settings: getSettingsCollection(state),
    backOrdersDataView: getBackOrdersDataView(state, state.store.pages.backOrders.getBackOrdersParameter),
    getBackOrdersParameter: state.store.pages.backOrders.getBackOrdersParameter,
    location: getLocation(state),
});

const mapDispatchToProps = {
    loadBackOrders,
    updateSearchFields,
};

type Props = PageProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps> & HasHistory;

const BackOrdersPage = ({
    loadBackOrders,
    updateSearchFields,
    backOrdersDataView,
    id,
    history,
    location,
    getBackOrdersParameter,
}: Props) => {
    let firstLoad = false;

    useEffect(() => {
        firstLoad = true;
        const pageSizeCookie = getCookie("BackOrders-PageSize");
        const pageSize = pageSizeCookie ? parseInt(pageSizeCookie, 10) : undefined;
        if (location.search) {
            const getBackOrdersApiParameter = parseQueryString<GetBackOrdersApiParameter>(location.search);
            if (pageSize) {
                getBackOrdersApiParameter.pageSize = pageSize;
            }
            updateSearchFields({ ...getBackOrdersApiParameter, type: "Replace" });
        } else {
            updateSearchFields({ type: "Initialize", pageSize });
        }
    }, []);

    useEffect(() => {
        if (!firstLoad) {
            const queryString = qs.stringify(getBackOrdersParameter);
            history.replace(`${location.pathname}${queryString !== "" ? `?${queryString}` : ""}`);
        }
    }, [getBackOrdersParameter]);

    useEffect(() => {
        // if this is undefined it means someone changed the filters and we haven't loaded the new collection yet
        if (!firstLoad && !backOrdersDataView.value && !backOrdersDataView.isLoading) {
            loadBackOrders(getBackOrdersParameter);
        } else if (
            !backOrdersDataView.isLoading &&
            backOrdersDataView.value?.length === 0 &&
            getBackOrdersParameter.page
        ) {
            updateSearchFields({ page: getBackOrdersParameter.page - 1 });
        }
    });

    return (
        <Page
            css={css`
                position: relative;
                flex-grow: 1;
            `}
        >
            <BackOrdersDataViewContext.Provider value={backOrdersDataView}>
                <Zone contentId={id} zoneName="Content" />
                <Modals skipInventoryValidation={true} skipProductPrice={true} />
            </BackOrdersDataViewContext.Provider>
        </Page>
    );
};

const pageModule: PageModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(withHistory(BackOrdersPage)),
    definition: {
        hasEditableUrlSegment: true,
        hasEditableTitle: true,
        pageType: "Content",
        fieldDefinitions: [
            MetaKeywords,
            MetaDescription,
            OpenGraphTitle,
            OpenGraphUrl,
            OpenGraphImage,
            StructuredPageData,
            {
                ...HorizontalRule,
            },
            HideHeader,
            HideFooter,
            HideFromSearchEngines,
            HideFromSiteSearch,
            ExcludeFromNavigation,
            ExcludeFromSignInRequired,
            {
                ...HorizontalRule,
            },
        ],
    },
};

export default pageModule;
